function omitDeleted<T>(collection: T[]): T[] {
  return collection.filter((node) => !node['deleted']);
}

export default omitDeleted;
